// ISO-3166 alpha-2 country list (curated, English names) for
// international signups once the worldwide toggle is on.
export const COUNTRIES = [
  ["AR", "Argentina"], ["AU", "Australia"], ["AT", "Austria"], ["BE", "Belgium"],
  ["BR", "Brazil"], ["BG", "Bulgaria"], ["CA", "Canada"], ["CL", "Chile"],
  ["CN", "China"], ["CO", "Colombia"], ["CR", "Costa Rica"], ["HR", "Croatia"],
  ["CY", "Cyprus"], ["CZ", "Czechia"], ["DK", "Denmark"], ["DO", "Dominican Republic"],
  ["EC", "Ecuador"], ["EG", "Egypt"], ["EE", "Estonia"], ["FI", "Finland"],
  ["FR", "France"], ["DE", "Germany"], ["GH", "Ghana"], ["GR", "Greece"],
  ["GT", "Guatemala"], ["HN", "Honduras"], ["HK", "Hong Kong"], ["HU", "Hungary"],
  ["IS", "Iceland"], ["IN", "India"], ["ID", "Indonesia"], ["IE", "Ireland"],
  ["IL", "Israel"], ["IT", "Italy"], ["JM", "Jamaica"], ["JP", "Japan"],
  ["KE", "Kenya"], ["KR", "South Korea"], ["LV", "Latvia"], ["LT", "Lithuania"],
  ["LU", "Luxembourg"], ["MY", "Malaysia"], ["MT", "Malta"], ["MX", "Mexico"],
  ["NL", "Netherlands"], ["NZ", "New Zealand"], ["NG", "Nigeria"], ["NO", "Norway"],
  ["PA", "Panama"], ["PE", "Peru"], ["PH", "Philippines"], ["PL", "Poland"],
  ["PT", "Portugal"], ["RO", "Romania"], ["SA", "Saudi Arabia"], ["RS", "Serbia"],
  ["SG", "Singapore"], ["SK", "Slovakia"], ["SI", "Slovenia"], ["ZA", "South Africa"],
  ["ES", "Spain"], ["SE", "Sweden"], ["CH", "Switzerland"], ["TW", "Taiwan"],
  ["TH", "Thailand"], ["TR", "Türkiye"], ["UA", "Ukraine"], ["AE", "United Arab Emirates"],
  ["GB", "United Kingdom"], ["UY", "Uruguay"], ["VN", "Vietnam"], ["ZZ", "Other / not listed"],
];
